import { SITE_TYPE } from "../constants";

export const ordersOriginsCodes = {
    web: `Por ${SITE_TYPE}`,
    portal: "Por portal"
};
